require('./cancelCardPayLaterWizardView.scss');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ actions
const cancelCardPayLaterActions = require('actions/cancelCardPayLater');
// @ commons
const { formatText } = require('core/i18n').i18n;
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const CardGenericConfirmationStep = require('components/contactCenter/cardGenericConfirmationStep/cardGenericConfirmationStep');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

// @ components
const CancelCardPayLaterSuccessStep = require('components/contactCenter/cancelCardPayLater/cancelCardPayLaterSuccessStep');
const CancelCardPayLaterErrorStep = require('components/contactCenter/cancelCardPayLater/cancelCardPayLaterErrorStep');

// @constants
const { WIZARD_VERTICAL_VIEW_MODE } = require('constants/index');
const { CIC_CHANNEL } = require('constants/index');
const { CANCEL_CARD_PAY_LATER_ID } = require('constants/contactCenter/operationTypes');

class CancelCardPayLaterWizardView extends React.Component {
    constructor(props) {
        super(props);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.beforeLeaving = this.beforeLeaving.bind(this);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleCancel() {
        const { history, match: { params: { cardId } } } = this.props;
        history.push(`/myprofile/cards/${cardId}/movements`);
    }

    handleConfirmLeave() {
        this.props.reset();
    }

    handleFinish() {
        const { match: { params: { cardId } } } = this.props;
        this.props.cancelCardPayLaterConfirm(cardId);
    }

    isReady() {
        this.props.reset();
        return this.props.immCards.get('inProgress');
    }

    beforeLeaving() {
        const { immCancelCardPayLater } = this.props;
        if (immCancelCardPayLater.get('submitSuccessful') && immCancelCardPayLater.get('willLeave')) {
            this.props.reset();
        }
    }

    buildWizard() {
        const { match: { params: { cardId } }, immCancelCardPayLater, validateStep, setVisibleStep, setWillCancel, immCards } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const immSteps = immCancelCardPayLater.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immCancelCardPayLater.get('visibleStep');
        const immFinalButton = 'mytransfers-pass';
        const originAccount = immCard.get('fullContractNumber').replace(/\s/g, '');
        const codigoPersona = immCard.get('person').get('personCode');
        const personaType = immCard.get('person').get('personType');
        const operativeName = formatText('cancelPayLater-operativeName');
        const operationParams = {
            "channel": CIC_CHANNEL,
            "originAccount": originAccount,
            "clientType": personaType,
            "clientId": codigoPersona
        }
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                >
                    <CardGenericConfirmationStep
                        operativeName={operativeName}
                        immCard={immCard}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton={immFinalButton}
                    addLoadingBehaviour={true}
                    omitPreviousButton={true}
                >
                    <VerifyOtpStep
                        operationType={CANCEL_CARD_PAY_LATER_ID}
                        operationParams={operationParams}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildContent() {
        const confirmationMessage = formatText('cancelPayLater-redirectConfirmationMessage');
        const confirmationTitle = formatText('cancelPayLater-redirectConfirmationTitle');
        const acceptText = formatText('cancelPayLater-redirectConfirmationAcceptButton');
        const cancelText = formatText('cancelPayLater-redirectConfirmationCancelButton');
        const wizard = this.buildWizard();
        return (
            <div>
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={this.isReady}
                    onConfirmLeave={this.handleConfirmLeave}
                />
                {wizard}
            </div>
        );
    }

    buildSuccessful() {
        return (
            <div className="row no-gutter">
                <div className="col-xs col-xs-12">
                    <CancelCardPayLaterSuccessStep />
                </div>
            </div>
        );
    }

    buildFailureView() {
        return (
            <div className="row no-gutter">
                <div className="col-xs col-xs-12">
                    <CancelCardPayLaterErrorStep />
                </div>
            </div>
        );
    }

    render() {
        const { immCancelCardPayLater } = this.props;
        const submitSuccessful = immCancelCardPayLater.get('submitSuccessful');
        const errorReceived = immCancelCardPayLater.get('errorReceived');
        const hasPayLaterMovements = immCancelCardPayLater.get('hasPayLaterMovements');
        const pageTitle = formatText('cancelPayLater-pageTitle');
        const { match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const mappingBreadcrumb = [
            {
                text: pageTitle,
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cardMoreOptions-payLater'),
                url: hasPayLaterMovements && __CONTACT_CENTER__ ? `/myprofile/cards/${cardId}/cancel-pay-later` : `/myprofile/cards/${cardId}/pay-later`
            },
            {
                text: formatText('cardMoreOptions-cancelPayLater'),
                url: ''
            }
        ]

        let content;
        if (submitSuccessful)
            content = this.buildSuccessful();
        else {
            if (!!errorReceived) {
                content = this.buildFailureView();
            }
            else
                content = this.buildContent();
        }

        return (
            <section>
                <OKHeaderCC
                    title={pageTitle}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                    submitSuccessful={submitSuccessful}
                    errorReceived={errorReceived}
                />
                <div>
                    {content}
                </div>
            </section>
        );
    }
}

CancelCardPayLaterWizardView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCancelCardPayLater: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setWillLeave: PropTypes.func.isRequired,
    cancelCardPayLaterConfirm: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
};

module.exports.constructor = CancelCardPayLaterWizardView;
module.exports.CancelCardPayLaterWizardView = connect(
    state => ({
        immCards: state.cards,
        immCancelCardPayLater: state.cancelCardPayLater
    }), {
    validateStep: cancelCardPayLaterActions.validateStep,
    setVisibleStep: cancelCardPayLaterActions.setVisibleStep,
    setWillCancel: cancelCardPayLaterActions.setWillCancel,
    setWillLeave: cancelCardPayLaterActions.setWillLeave,
    reset: cancelCardPayLaterActions.reset,
    cancelCardPayLaterConfirm: cancelCardPayLaterActions.cancelCardPayLaterConfirm
})(withRouter(CancelCardPayLaterWizardView));
